var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C10.8579 22.5 7.5 19.1421 7.5 15C7.5 10.8579 10.8579 7.5 15 7.5C19.1421 7.5 22.5 10.8579 22.5 15C22.5 19.1421 19.1421 22.5 15 22.5ZM13.75 1.25H16.25V5H13.75V1.25ZM13.75 25H16.25V28.75H13.75V25ZM4.3934 6.16116L6.16116 4.3934L8.81281 7.04505L7.04505 8.81281L4.3934 6.16116ZM21.1871 22.955L22.955 21.1871L25.6066 23.8389L23.8389 25.6066L21.1871 22.955ZM23.8389 4.3934L25.6066 6.16116L22.955 8.81281L21.1871 7.04505L23.8389 4.3934ZM7.04505 21.1871L8.81281 22.955L6.16116 25.6066L4.3934 23.8389L7.04505 21.1871ZM28.75 13.75V16.25H25V13.75H28.75ZM5 13.75V16.25H1.25V13.75H5Z",
    fill: "#1D1E24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTheme);
export default __webpack_public_path__ + "static/media/light-theme.caccb7895e0cf89a8829d119ab64bbab.svg";
export { ForwardRef as ReactComponent };